<section [ngClass]="fullWidth ? 'notifications-list-fullwidth' : 'notifications-list'">
  @for (notification of notifications; track notification; let isLast = $last) {
    <ac-notification
      [notification]="notification"
      [isLast]="isLast"
      [currentCategory]="currentCategory"
      (clicked)="_onClickNotification()"
    />
  } @empty {
    <div class="text-secondary-dark p-1 py-2">
      @if (_errorSig(); as error) {
        <ac-info-box error>
          <span class="paragraph-m">{{ error | translate }}</span>
        </ac-info-box>
      } @else if (!_loadingSig()) {
        <ac-no-data-found />
      }
    </div>
  }
</section>
